// extracted by mini-css-extract-plugin
module.exports = {"container":"Link__container___LgiZs","iconNewWindow":"Link__iconNewWindow___A+8Op"};